import { useMemo } from "react";
import { css } from "@emotion/css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { make as UnitImage } from "common/src/tft-static/UnitImage.bs";
import InputAdornment from "@mui/material/InputAdornment";
import { use as useTftSet } from "common/src/data/TftSet.bs";
import { useT } from "common/src/bindings/Translation.bs";
import { allUnits, allUnits2, unitTier } from "common/src/tft-static/Sd.ts";

export default function UnitAutocomplete({ onChange, defaultValue, altUnits }) {
  const set = useTftSet();
  const t = useT(1);

  const options = useMemo(() => {
    return (altUnits ? allUnits2(set) : allUnits(set))
      .sort((u1, u2) => unitTier(u2, set) - unitTier(u1, set))
      .map((unitId) => ({
        label: unitId,
        searchLabel: t(unitId).toLowerCase().replace("'", ""),
      }));
  }, [altUnits]);

  const defVal = options.find((opt) => opt.label == defaultValue);

  return (
    <Autocomplete
      filterOptions={(vs, state) => {
        const v = state.inputValue.toLowerCase().replace("'", "");
        return vs.filter(({ searchLabel }) => searchLabel.startsWith(v));
      }}
      defaultValue={defVal}
      autoHighlight
      options={options}
      onChange={(_, v) => v && onChange(v.label)}
      sx={{ width: 200 }}
      renderOption={(props, v) => {
        return (
          <li key={v.label} {...props}>
            <UnitImage unitId={v.label} size={28} showName={false} />
            <span className="font-montserrat font-medium inline text-base pl-[6px]">
              {t(v.label)}
            </span>
          </li>
        );
      }}
      renderInput={(params, v) => {
        return (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              value: t(params.inputProps.value),
            }}
            variant="standard"
            InputProps={{
              ...params.InputProps,
              classes: {
                input: css({ fontFamily: "Montserrat", fontWeight: "500" }),
              },
              startAdornment: (
                <InputAdornment position="start">
                  {t(params.inputProps.value) !== params.inputProps.value ? (
                    <UnitImage
                      unitId={params.inputProps.value}
                      size={28}
                      showName={false}
                    />
                  ) : (
                    <div />
                  )}
                </InputAdornment>
              ),
            }}
          />
        );
      }}
    />
  );
}
